// Pure helpers for app_cdn urls — kept free of `utils/index`'s side-effect imports (i18n, sounds) so any module,
// and its tests, can use them.
export const GCS_CDN_BASE_URL = "https://storage.googleapis.com/app_cdn/";

const DOUBLED_PREFIX = /^https?:\/\/storage\.googleapis\.com\/app_cdn\/(https?:\/\/.+)$/i;

/**
 * Some history rows come back with the CDN base stuck in front of an already-absolute url
 * (`https://storage.googleapis.com/app_cdn/https://storage.googleapis.com/app_cdn/user_uploaded/x.jpeg`). Nothing
 * can fetch that — a thumbnail renders black and the Miro export fails with "couldn't download". Returns the inner url
 * (peeling every repeat); any other url comes back untouched.
 */
export const collapseDoubledCdnPrefix = (url: string): string => {
  let current = url.trim();
  for (let guard = 0; guard < 5; guard += 1) {
    const match = DOUBLED_PREFIX.exec(current);
    if (!match) break;
    current = match[1];
  }

  return current;
};

/** An absolute url as is (a doubled CDN prefix collapsed); a relative path prefixed with the CDN base exactly once. */
export const toAbsoluteCdnUrl = (pathOrUrl: string): string => {
  const trimmed = collapseDoubledCdnPrefix(pathOrUrl);
  if (/^https?:\/\//i.test(trimmed)) return trimmed;

  return `${GCS_CDN_BASE_URL}${trimmed.replace(/^\/+/, "")}`;
};
